export default {
  dark: 'Mørk',
  light: 'Lys',
};
